import { baseConfiguration } from 'utils/constants/customizer';

export const STY902 = {
  ...baseConfiguration,
  name: 'vest',
  angleName: 'vest',
};
